import EmailList from "./list.js";

export default class {

    out
    resultsContainer
    queryInput
    list
    _options = {
        query: null,
        searchOnLoad: false,
    }

    constructor(opts) {
        this._options = {...this._options, ...opts}

        this.out = $('<div>').addClass('dataRow')

        this.queryInput = $('<input>')
            .val(this._options.query)
            .addClass('form-control')
            .attr('name', 'query')
            .attr('type', 'text')
            .html('starting...')
            .on('blur', ()=>{
            this.sendQuery(this.queryInput.val())
        })

        this.resultsContainer = $('<div>')
        this.out.append(this.queryInput,this.resultsContainer)

        if(this._options.searchOnLoad){
            this.sendQuery(this._options.query)

        }

    }

    get html(){
        return this.out
    }

    sendQuery(query){
        if(query === '') return
        this.resultsContainer.html(CS.Make.spinner)
        CS.ajaxCall({
            url: route('emails.searchdb'),
            data: {'query': query},
        }, (response) => {
            this.showResults(response.results)
        })
    }

    showResults(list){
        list = new EmailList(list, {Message: {selectable: true}})

        this.resultsContainer.html(list.html)
    }


}
